import React, { Component } from 'react';

// only for h1, cannot be used for h23 
class SimpleNestedTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredRow: null
    };
  }

  handleRowHover = (index) => {
    this.setState({ hoveredRow: index });
  };

  handleRowLeave = () => {
    this.setState({ hoveredRow: null });
  };

  render() {
    const baseTextStyle = {
      fontFamily: 'FontFirst2, Roboto',
      fontSize: '14px',
      whiteSpace: 'nowrap',
      textAlign: 'center',
      border: '1px solid #ccc',
      padding: '8px 4px',
    };

    const styles = {
      container: {
        padding: 10,
        marginTop: 10,
      },
      outer: {
        display: "flex",
        width: "100%",
        border: "1px solid #ccc",
        ...baseTextStyle,
      },
      fixedColumn: {
        minWidth: "100px",
        backgroundColor: "#f9f9f9",
      },
      scrollable: {
        flex: 1,
        overflowX: "auto",
        overflowY: "hidden",
      },
      table: {
        borderCollapse: "collapse",
        width: "max-content",
        minWidth: "100%",
      },
      header: {
        ...baseTextStyle,
        backgroundColor: "#f0f0f0",
        fontWeight: "bold",
        fontSize: "14px",
      },
      subHeader: {
        ...baseTextStyle,
        backgroundColor: "#f8f8f8",
        fontSize: "14px",
        fontWeight: "bold",
      },
      cell: {
        ...baseTextStyle,
        fontSize: "14px",
        textAlign: "center",
        transition: "background-color 0.2s ease",
      },
      cellHovered: {
        ...baseTextStyle,
        fontSize: "14px",
        textAlign: "center",
        backgroundColor: "#e3f2fd",
        transition: "background-color 0.2s ease",
      },
      dateCell: {
        ...baseTextStyle,
        backgroundColor: "#f9f9f9",
        fontWeight: "bold",
        position: "sticky",
        left: 0,
        zIndex: 1,
        transition: "background-color 0.2s ease",
      },
      dateCellHovered: {
        ...baseTextStyle,
        backgroundColor: "#e1f5fe",
        fontWeight: "bold",
        position: "sticky",
        left: 0,
        zIndex: 1,
        transition: "background-color 0.2s ease",
      },
      dateHeader: {
        ...baseTextStyle,
        backgroundColor: "#f0f0f0",
        fontWeight: "bold",
        position: "sticky",
        left: 0,
        zIndex: 2,
        fontSize: "14px",
      },
      row: {
        transition: "background-color 0.2s ease",
      },
      rowHovered: {
        backgroundColor: "#f0f8ff",
        transition: "background-color 0.2s ease",
      },
    };

    if(!this.props.data?.length || !this.props.config?.length){
        return <></>
    }

    return (
      <div style={styles.container}>
        <div style={styles.outer}>
          <div style={styles.fixedColumn}>
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
              <thead>
                <tr>
                  <th style={styles.dateHeader}>Tanggal</th>
                </tr>
                <tr>
                  <th style={styles.subHeader}>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {this.props.data?.map((row, index) => (
                  <tr 
                    key={index}
                    style={this.state.hoveredRow === index ? styles.rowHovered : styles.row}
                    onMouseEnter={() => this.handleRowHover(index)}
                    onMouseLeave={this.handleRowLeave}
                  >
                    <td style={this.state.hoveredRow === index ? styles.dateCellHovered : styles.dateCell}>
                      {row}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={styles.scrollable}>
            <table style={styles.table}>
              <thead>
                <tr>
                  {this.props.config?.map((category) => (
                    <th
                      key={category.label}
                      colSpan={category.key === "total" ? 2 : 3}
                      style={styles.header}
                    >
                      {category.label}
                    </th>
                  ))}
                </tr>
                <tr>
                  {this.props.config?.map((category) => (
                    <React.Fragment key={category.label}>
                      <th style={styles.subHeader}>Harian</th>
                      <th style={styles.subHeader}>Akumulasi</th>
                      {category.key !== "total" && (
                        <th style={styles.subHeader}>
                          {category.leasingName ? "%mscp" : "%sp"}
                        </th>
                      )}
                    </React.Fragment>
                  ))}
                </tr>
              </thead>
              <tbody>
                {this.props.data?.map((_, index) => (
                  <tr 
                    key={index}
                    style={this.state.hoveredRow === index ? styles.rowHovered : styles.row}
                    onMouseEnter={() => this.handleRowHover(index)}
                    onMouseLeave={this.handleRowLeave}
                  >
                    {this.props.config?.map((category) => (
                      <React.Fragment key={category.key + index}>
                        <td style={this.state.hoveredRow === index ? styles.cellHovered : styles.cell}>
                          {category.dailyCash?.[index + 1] ?? "-"}
                        </td>
                        <td style={this.state.hoveredRow === index ? styles.cellHovered : styles.cell}>
                          {category.dailyAccumulation?.[index + 1] ?? "-"}
                        </td>
                        {category.key !== "total" && (
                          <td style={this.state.hoveredRow === index ? styles.cellHovered : styles.cell}>
                            {category.percentSP?.[index + 1] ?? "-"}
                          </td>
                        )}
                      </React.Fragment>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default SimpleNestedTable;